export default "__VITE_ASSET__DoPe5TXe__"